export const LOAD_COGNITO_USER = 'LOAD_COGNITO_USER';
export const LOGOUT_COGNITO_USER = 'LOGOUT_COGNITO_USER';

export const LOAD_USER_INFO = 'LOAD_USER_INFO';
export const UNLOAD_USER_INFO = 'UNLOAD_USER_INFO';

export const LOAD_PROJECT = 'LOAD_PROJECT';
export const UNLOAD_PROJECT = 'UNLOAD_PROJECT';

export const SET_PROJECT_ID = 'SET_PROJECT_ID';
export const UNSET_PROJECT_ID = 'UNSET_PROJECT_ID';

export const UPDATE_SHOW_LOGICAL_LANGAGE = 'UPDATE_SHOW_LOGICAL_LANGAGE';

export const DEBUG_MODE = "DEBUG_MODE";
export const MENU_DRAWER = "MENU_DRAWER";
export const HELP_DRAWER = "HELP_DRAWER";
export const HELP_PAGE = "HELP_PAGE";
export const MODE = "MODE";